import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthHttpInterceptorService {
  constructor(private router: Router, private authService: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    console.log('interceptor running');
    // Get the token from auth service.
    const token$ = from(this.authService.getToken());

    const httpRequest$ = token$.pipe(
      switchMap((authToken) => {
        // console.log(authToken);

        if (authToken) {
          // Clone the request to add the new header.
          const authReq = req.clone({
            headers: req.headers
              .set('Authorization', `Bearer ${authToken}`)
              // .set('Content-Type', 'application/json'),
          });
          console.log('interceptor running with new headers');

          // send the newly created request
          return next.handle(authReq).pipe(
            tap(
              (event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                  // Response wiht HttpResponse type
                  // console.log('TAP function', event);
                }
              },
              (err: any) => {
                console.log(err);
                if (err instanceof HttpErrorResponse) {
                  if (err.status === 401) {
                    // this.authService.removeToken();
                    // localStorage.removeItem('token');
                    // this.router.navigate(['/']);
                  }
                }
              }
            )
          );
        } else {
          console.log('interceptor without changes');
          return next.handle(req);
        }
      })
    );

    return httpRequest$;
  }
}
